import _ from "lodash";
import { TRANSCRIPT_CAN_MANAGE_ACADEMIC_RECORDS_PERMISSION } from "Constants/permissionConstants";

export const hasPermission = ({
  permissionMap,
  permission,
  curriculumProgramId,
}) => {
  if (_.isNil(permissionMap)) return false;

  // Account-level permission check
  if (_.get(permissionMap, "account", new Set()).has(permission)) {
    return true;
  }

  // School-level permission check
  if (!_.isNil(curriculumProgramId)) {
    const schoolPermissions = _.get(
      permissionMap,
      ["school", curriculumProgramId],
      new Set()
    );
    return schoolPermissions.has(permission);
  }

  return false;
};

export const getSchoolsWithPermission = ({ permissionMap, permission }) => {
  const schoolPermissions = _.get(permissionMap, "school", {});
  return _.reduce(
    schoolPermissions,
    (result, permissions, curriculumId) => {
      if (_.isObject(permissions) && permissions.has(permission)) {
        result = _.concat(result, curriculumId);
      }
      return result;
    },
    []
  );
};

export const hasPermissionInAnySchool = ({ permissionMap, permission }) => {
  const schoolPermissions = _.get(permissionMap, "school", {});
  return _.some(
    schoolPermissions,
    permissions => _.isObject(permissions) && permissions.has(permission)
  );
};

export const hasManageTranscriptsRecordsPermission = ({
  permissionMap,
  curriculumProgramId,
}) => {
  return hasPermission({
    permissionMap,
    permission: TRANSCRIPT_CAN_MANAGE_ACADEMIC_RECORDS_PERMISSION,
    curriculumProgramId,
  });
};
